<div class="n-oldalfej">
  <div>
    <h2>Letiltások</h2>
    <span class="n-alcim">Végrehajtási ügyek tételesen – a levonás a Vht. 61–65. §-a szerint</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Munkavállaló
    <select [(ngModel)]="alkalmazottId" (ngModelChange)="betolt()">
      <option *ngFor="let a of alkalmazottak" [value]="a.id">{{ a.nev }}</option>
    </select>
  </label>
  <label class="ev-valaszto" title="Az adott hónap végi állapot visszanézése">Állapot
    <select [(ngModel)]="visszaEv" (ngModelChange)="visszaValt()">
      <option [ngValue]="null">mai</option>
      <option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option>
    </select>
    <select *ngIf="visszaEv" [(ngModel)]="visszaHo" (ngModelChange)="betolt()">
      <option *ngFor="let h of [1,2,3,4,5,6,7,8,9,10,11,12]" [ngValue]="h">{{ h }}. hó</option>
    </select>
  </label>
  <ion-button (click)="ujUgy()" [disabled]="!alkalmazottId"><ion-icon slot="start" name="add"></ion-icon>Új letiltás</ion-button>
</div>
<div class="lt-halvany-sor" *ngIf="honapAllapot" style="margin:0 0 8px">
  <b>{{ honapAllapot.ev }}. {{ honapAllapot.ho }}. hó végi állapot</b> – a hátralék és a kamat {{ honapAllapot.vege }}-ig számolva,
  a tételeknél a hónap levonásával. <a href="javascript:void(0)" (click)="maiAllapot()">Vissza a mai állapothoz</a>
</div>

<!-- Fülek + összegző csempék -->
<div class="lt-fulek">
  <button type="button" [class.aktiv]="nezet === 'ugyek'" (click)="nezetValt('ugyek')">
    <ion-icon name="hammer-outline"></ion-icon>Ügyek<span class="db" *ngIf="aktivDb">{{ aktivDb }}</span></button>
  <button type="button" [class.aktiv]="nezet === 'utalas'" (click)="nezetValt('utalas')">
    <ion-icon name="send-outline"></ion-icon>Utalási lista</button>
  <button type="button" [class.aktiv]="nezet === 'proba'" (click)="nezetValt('proba')">
    <ion-icon name="calculator-outline"></ion-icon>Próbaszámítás</button>
</div>

<div class="lt-csempek" *ngIf="nezet === 'ugyek' && ugyek.length">
  <div class="lt-csempe">
    <div class="cim">Fennálló tartozás</div>
    <div class="ertek">{{ szam(osszesHatralek) }} <small>Ft</small></div>
    <div class="jel">{{ aktivDb }} aktív ügy{{ szunetelDb ? ' · ' + szunetelDb + ' szünetel' : '' }}</div>
  </div>
  <div class="lt-csempe">
    <div class="cim">Eddig levonva</div>
    <div class="ertek">{{ szam(osszesTeljesitve) }} <small>Ft</small></div>
    <div class="jel">{{ szazalekTeljesitve }}% a követelésből</div>
  </div>
  <div class="lt-csempe" *ngIf="honapAllapot">
    <div class="cim">A hónap levonása</div>
    <div class="ertek">{{ szam(honapLevonas) }} <small>Ft</small></div>
    <div class="jel">{{ honapAllapot.ev }}. {{ honapAllapot.ho }}. hó</div>
  </div>
  <div class="lt-csempe" *ngIf="utolsoHavi && !honapAllapot">
    <div class="cim">Utolsó havi levonás</div>
    <div class="ertek">{{ szam(utolsoHavi.osszeg) }} <small>Ft</small></div>
    <div class="jel">{{ utolsoHavi.ev }}. {{ utolsoHavi.ho }}. hó</div>
  </div>
</div>

<!-- ══════════ ÜGYEK ══════════ -->
<ng-container *ngIf="nezet === 'ugyek'">
  <div class="lt-ures" *ngIf="!betoltes && !ugyek.length">
    <ion-icon name="document-text-outline"></ion-icon>
    <div class="cim">Nincs rögzített letiltás</div>
    <p>Ha végrehajtói letiltás érkezett, vedd fel új ügyként, majd rögzítsd a tételeit –
      minden tételnek saját kedvezményezettje és bankszámlája van.</p>
    <button type="button" class="ov-gomb fo" (click)="ujUgy()" [disabled]="!alkalmazottId">
      <ion-icon name="add"></ion-icon>Új letiltás</button>
  </div>

  <article class="lt-ugy" *ngFor="let u of ugyek" [attr.data-allapot]="u.allapot">
    <header class="lt-ugy-fej" (click)="nyitott[u.id] = !nyitott[u.id]">
      <div class="lt-allapot" [attr.data-a]="u.allapot" [title]="allapotCimke(u.allapot)"></div>
      <div class="lt-cim">
        <div class="sor1">
          <b>{{ u.ugyszam || 'ügyszám nélkül' }}</b>
          <span class="lt-pill" [attr.data-a]="u.allapot">{{ allapotCimke(u.allapot) }}</span>
          <span class="lt-pill halk">{{ csoportNev(u.csoport) }}</span>
          <span class="lt-pill halk" *ngIf="u.havi_max">max {{ szam(u.havi_max) }} Ft/hó</span>
        </div>
        <div class="sor2">
          <span *ngIf="u.jogosult"><ion-icon name="business-outline"></ion-icon>{{ u.jogosult }}</span>
          <span *ngIf="u.vegrehajto"><ion-icon name="briefcase-outline"></ion-icon>{{ u.vegrehajto }}</span>
          <span *ngIf="u.jutalek_szazalek"><ion-icon name="pricetag-outline"></ion-icon>{{ u.jutalek_szazalek }}% jutalék</span>
        </div>
        <div class="sor3" *ngIf="u.allapot !== 'aktiv' && (u.allapot_datum || u.allapot_megjegyzes)">
          {{ u.allapot_datum | date:'yyyy.MM.dd' }} {{ u.allapot_megjegyzes }}
        </div>
      </div>
      <div class="lt-merleg">
        <div class="lt-savok">
          <div class="lt-sav"><span [style.width.%]="arany(u)"></span></div>
          <div class="lt-sav-cim">{{ szam(teljesitett(u)) }} / {{ szam(koveteles(u)) }} Ft</div>
        </div>
        <div class="lt-hatralek">
          <span class="halvany">hátralék</span>
          <b>{{ szam(u.hatralek) }} Ft</b>
        </div>
      </div>
      <div class="lt-muvelet" (click)="$event.stopPropagation()">
        <button type="button" (click)="szerkeszt(u)" title="Ügy adatai"><ion-icon name="create-outline"></ion-icon></button>
        <button type="button" class="torol" (click)="ugyTorol(u)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
        <ion-icon class="lt-nyil" [name]="nyitott[u.id] ? 'chevron-up' : 'chevron-down'"></ion-icon>
      </div>
    </header>

    <div class="lt-torzs" *ngIf="nyitott[u.id]">
      <!-- tételek -->
      <div class="lt-szekcio-fej">
        <h4>Tételek <span class="halvany">kielégítési sorrendben</span></h4>
        <button type="button" class="ov-gomb" (click)="ujTetel(u)"><ion-icon name="add-outline"></ion-icon>Tétel</button>
        <button type="button" class="ov-gomb" *ngIf="u.tetelek?.length" (click)="korabbiNyit(u)"
                title="A rendszer előtti (vagy máshol számfejtett) hónapok levonásai a végrehajtói kimutatás szerint">
          <ion-icon name="time-outline"></ion-icon>Korábbi levonás rögzítése</button>
      </div>
      <div class="lt-tetel" *ngFor="let t of u.tetelek" [class.kifutott]="t.hatralek === 0" [class.szamitott]="t.szamitott">
        <div class="sorsz">{{ t.sorrend }}</div>
        <div class="nev">
          <b>{{ t.megnevezes || tipusNev(t.tipus) }}</b>
          <span class="lt-pill mini" *ngIf="t.szamitott">havonta számolt</span>
          <span class="lt-pill mini petrol" *ngIf="t.kamat_szamitott"
                [title]="'Induló (a kezdő napig felhalmozott) kamat: ' + szam(t.kamat_szamitott.indulo) + ' Ft + folyó kamat a főkövetelés hátraléka után, évi ' + t.kamat_szamitott.szazalek + '%, ' + t.kamat_szamitott.tol + ' – ' + t.kamat_szamitott.ig + ' (' + t.kamat_szamitott.napok + ' nap): ' + szam(t.kamat_szamitott.folyo) + ' Ft'">
            + folyó kamat {{ t.kamat_szamitott.szazalek }}%/év: {{ szam(t.kamat_szamitott.folyo) }} Ft</span>
          <span class="lt-pill mini petrol" *ngIf="t.jutalek_alap" title="A behajtási jutalék alapjába tartozik">jutalékalap</span>
          <div class="kedv">
            <ion-icon name="person-outline"></ion-icon>{{ t.kedvezmenyezett || 'nincs megadva' }}
            <span class="szla" *ngIf="t.bankszamla">{{ t.bankszamla }}</span>
          </div>
        </div>
        <div class="osszegek">
          <div><span>követelés</span><b>{{ t.koveteles_szamitott != null ? szam(t.koveteles_szamitott) : (t.osszeg == null ? '—' : szam(t.osszeg)) }}</b></div>
          <div><span>teljesítve</span><b>{{ szam(t.teljesitve) }}</b></div>
          <div *ngIf="honapAllapot"><span>a hónapban</span><b>{{ szam(t.honap_levonas) }}</b></div>
          <div class="kiemelt"><span>hátralék</span><b>{{ t.hatralek == null ? '—' : szam(t.hatralek) }}</b></div>
        </div>
        <div class="muv">
          <button type="button" (click)="tetelSzerkeszt(t)" title="Módosítás"><ion-icon name="create-outline"></ion-icon></button>
          <button type="button" class="torol" (click)="tetelTorol(t)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
        </div>
      </div>
      <p class="lt-halvany-sor" *ngIf="!u.tetelek?.length">
        Még nincs tétel. A levonás csak tételekre osztható szét – vedd fel a követelés részeit (költségek, kamat, főkövetelés).
      </p>

      <!-- havi kimutatás -->
      <ng-container *ngIf="vanTeljesites(u)">
        <div class="lt-szekcio-fej"><h4>Havi kimutatás</h4></div>
        <table class="lt-tabla">
          <thead><tr><th>Hónap</th><th>Tétel</th><th>Kedvezményezett</th><th class="num">Levonás</th><th class="num">Fennmaradó</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let h of havi(u)">
              <td><b>{{ h.ev }}. {{ h.ho }}.</b> <span class="lt-pill mini" *ngIf="h.kezi" [title]="h.megjegyzes || 'kézzel rögzített korábbi levonás'">kézi</span></td>
              <td>{{ h.megnevezes }}</td>
              <td class="halvany">{{ h.kedvezmenyezett }}</td>
              <td class="num">{{ szam(h.osszeg) }}</td>
              <td class="num halvany">{{ h.maradek == null ? '—' : szam(h.maradek) }}</td>
              <td class="muv"><button type="button" class="torol" *ngIf="h.kezi && h.elso" (click)="korabbiTorol(u, h)"
                      title="E hónap kézi levonásainak törlése"><ion-icon name="trash-outline"></ion-icon></button></td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </article>
</ng-container>

<!-- ══════════ UTALÁSI LISTA ══════════ -->
<ng-container *ngIf="nezet === 'utalas'">
  <div class="lt-szuro">
    <label>Év <input type="number" [(ngModel)]="ev" (ngModelChange)="utalasBetolt()"></label>
    <label>Hónap <input type="number" min="1" max="12" [(ngModel)]="ho" (ngModelChange)="utalasBetolt()"></label>
    <span class="spacer"></span>
    <b *ngIf="utalasok.length">Összesen {{ szam(utalasOsszesen) }} Ft</b>
  </div>
  <div class="lt-ures" *ngIf="!utalasok.length">
    <ion-icon name="send-outline"></ion-icon>
    <div class="cim">Ebben a hónapban nincs letiltás-utalás</div>
    <p>Az utalási lista a számfejtés mentésekor keletkezik.</p>
  </div>
  <div class="lt-utalas" *ngFor="let u of utalasok">
    <div class="lt-utalas-fo">
      <div>
        <b>{{ u.kedvezmenyezett || 'nincs megadva' }}</b>
        <div class="szla">{{ u.bankszamla || 'nincs bankszámla megadva' }}</div>
      </div>
      <div class="osszeg">{{ szam(u.osszeg) }} <small>Ft</small></div>
    </div>
    <div class="lt-utalas-tetelek">
      <span *ngFor="let t of u.tetelek">{{ t.alkalmazott }} · {{ tipusNev(t.tipus) }}
        <em *ngIf="t.ugyszam">({{ t.ugyszam }})</em> — {{ szam(t.osszeg) }} Ft</span>
    </div>
  </div>
  <!-- Banki átutalási csomag: a kedvezményezetti utalások Electra .HUF állományban.
       A csomag ÜGYENKÉNT bont (a közleményben az ügyszám kell), a lista fölötte számlánként von össze. -->
  <app-ber-electra-panel fajta="letiltas" [ev]="ev" [ho]="ho"></app-ber-electra-panel>
</ng-container>

<!-- ══════════ PRÓBASZÁMÍTÁS ══════════ -->
<ng-container *ngIf="nezet === 'proba'">
  <div class="lt-proba">
    <div class="lt-proba-be">
      <label>Nettó munkabér <input type="number" [(ngModel)]="probaNetto" placeholder="pl. 400000"></label>
      <button type="button" class="ov-gomb fo" (click)="probaSzamol()" [disabled]="!alkalmazottId">Számítás</button>
    </div>
    <p class="halvany">A levonható hányadot a törvény adja: a százalékos korlát, a nyugdíjminimum
      ötszöröse feletti korlátlan rész és a mentes rész együtt (Vht. 61–65. §).</p>

    <ng-container *ngIf="proba">
      <div class="lt-proba-osszeg">
        <div><span>levonható</span><b>{{ szam(proba.levonas) }} Ft</b></div>
        <div><span>a munkavállalónál marad</span><b>{{ szam(proba.marad) }} Ft</b></div>
        <div><span>alkalmazott hányad</span><b>{{ proba.szazalek }}%</b></div>
      </div>
      <div class="lt-torveny">
        <div><i>Vht. 65. §</i> {{ proba.szazalek }}% = {{ szam(proba.keret?.szazalekos) }} Ft</div>
        <div><i>Vht. 63. §</i> a nyugdíjminimum ötszöröse ({{ szam(proba.keret?.nyugdijminimum * 5) }} Ft) feletti rész
          <b>{{ szam(proba.keret?.korlatlan) }} Ft</b> korlátlanul</div>
        <div><i>Vht. 62. §</i> mentes {{ szam(proba.keret?.nyugdijminimum) }} Ft – ennyi mindenképp a munkavállalónál marad</div>
      </div>
      <table class="lt-tabla" *ngIf="proba.sorok?.length">
        <thead><tr><th>Ügy</th><th>Tétel</th><th>Kedvezményezett</th><th class="num">Összeg</th></tr></thead>
        <tbody>
          <tr *ngFor="let s of proba.sorok">
            <td class="halvany">{{ s.ugyszam }}</td><td>{{ s.megnevezes }}</td>
            <td>{{ s.kedvezmenyezett || '—' }}</td><td class="num"><b>{{ szam(s.osszeg) }}</b></td>
          </tr>
        </tbody>
      </table>
      <p class="lt-halvany-sor" *ngIf="!proba.sorok?.length">Nincs aktív letiltás, amire a levonás menne.</p>
    </ng-container>
  </div>
</ng-container>

<!-- ══════════ SZERKESZTŐK ══════════ -->
<ion-modal [isOpen]="!!szerk" (didDismiss)="ugyBezar()" cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>{{ szerk?.id ? 'Letiltás módosítása' : 'Új letiltás' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="ugyBezar()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs" *ngIf="szerk">
      <div class="nk-form">
        <app-szerk-zar-sav [zar]="zarUgy"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Ügyszám</span><input type="text" [(ngModel)]="szerk.ugyszam" placeholder="287.V.0044/2018/89"></label>
        <label class="kv-mezo"><span>Jogosult</span><input type="text" [(ngModel)]="szerk.jogosult" placeholder="a követelés jogosultja"></label>
        <label class="kv-mezo"><span>Végrehajtói iroda</span><input type="text" [(ngModel)]="szerk.vegrehajto"></label>
        <label class="kv-mezo"><span>Besorolás</span>
          <select [(ngModel)]="szerk.csoport"><option *ngFor="let c of torzsek.csoportok" [value]="c.kulcs">{{ c.nev }}</option></select></label>
        <p class="kv-sugo">A besorolás dönti el a sorrendet több letiltás között (Vht. 165. §) és azt, hogy 33% vagy 50%
          vonható le (65. §). Tartásdíjnál a mentes rész sem véd (62. §).</p>
        <label class="kv-mezo"><span>Beérkezett</span><input type="date" [(ngModel)]="szerk.erkezett"></label>
        <p class="kv-sugo">Azonos besorolású letiltásoknál a korábban érkezett elégül ki előbb (Vht. 64. §).</p>
        <label class="kv-mezo"><span>Állapot</span>
          <select [(ngModel)]="szerk.allapot">
            <option value="aktiv">aktív</option><option value="felfuggesztve">végrehajtó felfüggesztette</option>
            <option value="megszuntetve">eljárás megszüntetve</option><option value="lezart">lezárt</option>
          </select></label>
        <ng-container *ngIf="szerk.allapot !== 'aktiv'">
          <label class="kv-mezo"><span>Állapot dátuma</span><input type="date" [(ngModel)]="szerk.allapot_datum"></label>
          <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.allapot_megjegyzes"></label>
        </ng-container>
        <label class="kv-mezo"><span>Behajtási jutalék %</span><input type="number" step="0.01" [(ngModel)]="szerk.jutalek_szazalek"></label>
        <p class="kv-sugo">A végrehajtói irodát illeti, a követelésre ténylegesen behajtott összeg után.</p>
        <label class="kv-mezo"><span>Havi felső összeg</span><input type="number" [(ngModel)]="szerk.havi_max" placeholder="üresen: a törvényi keret"></label>
        <p class="kv-sugo">Ha a határozat a törvényinél kevesebbet ír elő. A törvényi korlátot nem lehet feljebb vinni.</p>
        <label class="kv-mezo"><span>Tőkekamat évi %</span><input type="number" step="0.01" [(ngModel)]="szerk.kamat_szazalek"></label>
        <label class="kv-mezo"><span>Kamat ettől</span><input type="date" [(ngModel)]="szerk.kamat_tol"></label>
        <p class="kv-sugo">A „Főkövetelés kamatai” tétel követelése = a tétel összege (a végrehajtói kimutatásban a „kamat ettől” napig
          felhalmozott kamat) + a folyó kamat, amit a program számol: a főkövetelés mindenkori hátraléka után, évi kamatlábbal, napra
          arányosan a megadott naptól az elszámolás napjáig (számfejtésnél a hónap végéig).</p>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="ugyMent()" [disabled]="zarUgy && !zarUgy.irhato"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Korábbi (a rendszer előtti) levonás visszarögzítése egy hónapra, tételenként -->
<ion-modal [isOpen]="!!korabbi" (didDismiss)="korabbi = null" cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>Korábbi levonás rögzítése</ion-title>
      <ion-buttons slot="end"><ion-button (click)="korabbi = null">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs" *ngIf="korabbi">
      <div class="nk-form">
        <p class="kv-sugo">A végrehajtói kimutatás szerint add meg, melyik hónapban mennyi ment az egyes tételekre. Ha a hónapot később a
          rendszer számfejti, a számfejtés felülírja. Egy hónap újbóli rögzítése a korábbi kézi sorait cseréli.</p>
        <label class="kv-mezo"><span>Év</span><input type="number" [(ngModel)]="korabbi.ev"></label>
        <label class="kv-mezo"><span>Hónap</span>
          <select [(ngModel)]="korabbi.ho"><option *ngFor="let h of [1,2,3,4,5,6,7,8,9,10,11,12]" [ngValue]="h">{{ h }}.</option></select></label>
        <label class="kv-mezo"><span>Levont összeg (szétosztáshoz)</span>
          <input type="number" [(ngModel)]="korabbi.osszesen" placeholder="opcionális"></label>
        <div class="nk-lab"><button type="button" class="ov-gomb" (click)="korabbiSzetoszt()" [disabled]="!korabbi.osszesen">
          <ion-icon name="git-merge-outline"></ion-icon>Szétosztás kielégítési sorrendben</button></div>
        <label class="kv-mezo" *ngFor="let t of korabbi.tetelek">
          <span>{{ t.nev }} <small class="halvany" *ngIf="t.hatralek != null">(hátralék {{ szam(t.hatralek) }})</small></span>
          <input type="number" [(ngModel)]="t.osszeg"></label>
        <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="korabbi.megjegyzes" placeholder="pl. végrehajtói kimutatás 2025.12.10."></label>
        <div class="nk-lab"><span class="halvany">Összesen: {{ szam(korabbiOsszeg) }} Ft</span><span class="spacer"></span>
          <button type="button" class="ov-gomb fo" (click)="korabbiMent()"><ion-icon name="save-outline"></ion-icon>Rögzítés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="!!tetelSzerk" (didDismiss)="tetelBezar()" cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>{{ tetelSzerk?.id ? 'Tétel módosítása' : 'Új tétel' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="tetelBezar()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs" *ngIf="tetelSzerk">
      <div class="nk-form">
        <app-szerk-zar-sav [zar]="zarTetel"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Típus</span>
          <select [(ngModel)]="tetelSzerk.tipus" (ngModelChange)="tipusValt()">
            <option *ngFor="let t of torzsek.tetelTipusok" [value]="t.kulcs">{{ t.nev }}</option>
          </select></label>
        <label class="kv-mezo"><span>Sorrend</span><input type="number" [(ngModel)]="tetelSzerk.sorrend"></label>
        <p class="kv-sugo">A kielégítés sorrendje az ügyön belül; a típus alapértékét a végrehajtói határozat felülírhatja.</p>
        <label class="kv-mezo"><span>Megnevezés</span><input type="text" [(ngModel)]="tetelSzerk.megnevezes" placeholder="ha a típus nevétől eltér"></label>
        <label class="kv-mezo"><span>Követelés összege</span><input type="number" [(ngModel)]="tetelSzerk.osszeg" [placeholder]="tetelSzerk.tipus === 'kamat' ? 'a kamat-kezdőnapig felhalmozott kamat – erre jön a folyó kamat' : 'havonta számolt tételnél üres'"></label>
        <label class="kv-mezo"><span>Kedvezményezett</span><input type="text" [(ngModel)]="tetelSzerk.kedvezmenyezett"></label>
        <label class="kv-mezo"><span>Bankszámla</span><input type="text" [(ngModel)]="tetelSzerk.bankszamla"></label>
        <label class="kv-mezo"><span>Közlemény</span><input type="text" [(ngModel)]="tetelSzerk.kozlemeny"></label>
        <div class="nk-kapcs"><label><input type="checkbox" [(ngModel)]="tetelSzerk.jutalek_alap"> Beleszámít a behajtási jutalék alapjába</label></div>
        <p class="kv-sugo">A jogosult követelésére menő tételeknél igen, a végrehajtói iroda saját költségeinél nem.</p>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="tetelMent()" [disabled]="zarTetel && !zarTetel.irhato"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>
